import {ComponentProps, Fragment, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/platforms/admin/externalDealer";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import {Button, message, Popconfirm, Space, Select as AntSelect} from "antd";
import Divider from "../../../../components/Divider";
import useFormModal from "../../../../utils/useFormModal";
import ModifyModal from "./components/ModifyModal";
import {useRequest} from "ahooks";
import UploadModal from "../../../../components/UploadModal";
import withAuth from "../../../../utils/withAuth";

const sysNameOptions = [
    {value: '美年', label: '美年'},
    {value: '新美年', label: '新美年'},
    {value: '云医购', label: '云医购'}
]



const AddButton = withAuth('add', Button);
const EditFragment = withAuth('edit', Fragment);
const ImportButton = withAuth('import', Button);

function ExternalDealer(props: ComponentProps<any>) {

    const [importModalVisible, setImportModalVisible] = useState(false);

    const {tableProps, search, form, refresh} = useAntTable(api.getExternalDealers, {defaultParams: {sysName: '美年'}});

    const {modalProps, setVisible} = useFormModal({
        onRequest: api.updateExternalDealer,
        onOk() {
            setVisible(false);
            refresh();
        }
    });

    const {loading: loadingDelete, run: runDelete} = useRequest(api.deleteExternalDealer, {
        manual: true,
        onSuccess(res) {
            refresh();
        }
    });

    const {loading: loadingImport, run: runImport} = useRequest(api.importExternalDealers, {
        manual: true,
        onSuccess(res) {
            message.success('导入成功');
            setImportModalVisible(false);
            refresh();
        }
    });

    const columns: StandardColumnsType = [
        {
            dataIndex: 'customerNo',
            title: '客户编号'
        },
        {
            dataIndex: 'customerName',
            title: '客户名称'
        },
        {
            dataIndex: 'externalCustomerNo',
            title: '外部客户编号'
        },
        {
            dataIndex: 'externalCustomerName',
            title: '外部客户名称'
        },
        {
            dataIndex: 'operation',
            title: '操作',
            render(v, r: any, i) {
                return (
                    <Divider>
                        <EditFragment>
                            <a onClick={() => setVisible(true, r)}>编辑</a>
                            <Popconfirm title={'是否确认删除映射关系？'} onConfirm={() => runDelete(r.id)}>
                                <a style={{color: 'var(--danger-color)'}}>删除</a>
                            </Popconfirm>
                        </EditFragment>
                    </Divider>
                )
            }
        }
    ];
    const searchColumns: StandardColumnsType = [
        {
            dataIndex: 'sysName',
            title: '外部系统',
            search: {
                valueRender(){
                    return <AntSelect defaultValue={'美年'} options={sysNameOptions} onChange={()=>search.submit()}/>
                },
                valueType: 'select',
                valueInitial: '美年',
            }
        },
        {
            dataIndex: 'cusNoOrName',
            title: '客户编号/名称',
            search: true
        },
    ];


    const toolbar = <Space>
        <AddButton type={"primary"} onClick={() => setVisible(true, {sysName: form.getFieldValue('sysName')})}>增加</AddButton>
        <ImportButton type={"primary"} onClick={() => setImportModalVisible(true)}>导入</ImportButton>
    </Space>

    return <PageHeaderLayout>
        <StandardTable {...tableProps} submit={search.submit} columns={columns} form={form}
                       extSearchColumns={searchColumns} toolbar={toolbar} search={search}/>
        <ModifyModal key={'modify-modal'} {...modalProps}/>
        <UploadModal key={'import-modal'}
                     open={importModalVisible}
                     onUpload={(f)=>runImport(f,form.getFieldValue('sysName'))}
                     template={'/template/外部系统客户映射导入模板.xlsx'}
                     confirmLoading={loadingImport}
                     onCancel={() => setImportModalVisible(false)}/>
    </PageHeaderLayout>
}

export default ExternalDealer;
